import { useState } from "react";
import { faqs } from "@/mocks/gossip";

export default function FaqAccordion() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <div className="divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200 bg-background-50">
      {faqs.map((faq, index) => {
        const isOpen = openIndex === index;
        return (
          <div key={faq.q}>
            <h3>
              <button
                type="button"
                onClick={() => setOpenIndex(isOpen ? null : index)}
                aria-expanded={isOpen}
                className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-left transition-colors hover:bg-background-100"
              >
                <span className="font-heading text-sm md:text-base font-semibold text-foreground-950">{faq.q}</span>
                <i
                  className={`${isOpen ? "ri-subtract-line" : "ri-add-line"} w-5 h-5 flex flex-shrink-0 items-center justify-center text-primary-600`}
                ></i>
              </button>
            </h3>
            {isOpen ? (
              <div className="px-5 pb-5 animate-fade-in">
                <p className="text-sm leading-relaxed text-foreground-600">{faq.a}</p>
              </div>
            ) : null}
          </div>
        );
      })}
    </div>
  );
}